import { CountryIconProps } from './types';

const IN = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3642)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9997 -0.000976562C7.24218 -0.000976562 3.13143 2.7677 1.19043 6.78165H22.8089C20.868 2.7677 16.7572 -0.000976562 11.9997 -0.000976562Z"
        fill="#FF9811"
      />
      <path
        d="M11.9997 23.9997C16.7572 23.9997 20.868 21.231 22.809 17.217H1.19043C3.13143 21.231 7.24218 23.9997 11.9997 23.9997Z"
        fill="#6DA544"
      />
      <path
        d="M12.0001 16.1732C14.3052 16.1732 16.174 14.3045 16.174 11.9993C16.174 9.69415 14.3052 7.82544 12.0001 7.82544C9.69489 7.82544 7.82617 9.69415 7.82617 11.9993C7.82617 14.3045 9.69489 16.1732 12.0001 16.1732Z"
        fill="#0052B4"
      />
      <path
        d="M12.0003 14.608C13.441 14.608 14.609 13.44 14.609 11.9993C14.609 10.5586 13.441 9.39062 12.0003 9.39062C10.5595 9.39062 9.3916 10.5586 9.3916 11.9993C9.3916 13.44 10.5595 14.608 12.0003 14.608Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.0007 8.78088L12.8055 10.6061L14.7885 10.3904L13.6102 12L14.7885 13.6095L12.8055 13.3939L12.0007 15.2191L11.1959 13.3939L9.21289 13.6095L10.3911 12L9.21289 10.3904L11.1959 10.6061L12.0007 8.78088Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3642">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default IN;
